import { render, staticRenderFns } from "./WangLuoTaiShi.vue?vue&type=template&id=42090440&scoped=true&"
import script from "./WangLuoTaiShi.vue?vue&type=script&lang=js&"
export * from "./WangLuoTaiShi.vue?vue&type=script&lang=js&"
import style0 from "./WangLuoTaiShi.vue?vue&type=style&index=0&id=42090440&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42090440",
  null
  
)

export default component.exports